// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fbr96","fullView":"styles_fullView__3gY5y"};